<template>
  <div class="aftermarket">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="售后查件">
          <div class="content">
            <el-form ref="form" :rules="rules" :model="form" label-width="100px">
              <el-form-item label="问题类型:" prop="type">
                <el-radio-group v-model="form.type" @change="onSelectType">
                  <el-radio label="sheet">底单申请</el-radio>
                  <el-radio label="parts">物流异常</el-radio>
                  <el-radio label="other">其他问题</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="快递单号:" prop="express_nos">
                <el-input
                    :autosize="{ minRows: 4}"
                    v-model="form.express_nos"
                    placeholder="多个物流单号用逗号隔开"
                    style="width: 300px;"
                    type="textarea"/>
              </el-form-item>

              <el-form-item label="问题描述:" prop="desc">
                <el-input
                    :autosize="{ minRows: 4}"
                    v-model="form.desc"
                    placeholder="请输入问题描述，越详细越好"
                    style="width: 300px;"
                    type="textarea"/>
              </el-form-item>

              <el-form-item label="上传图片:" prop="images">
                <el-upload
                    ref="images"
                    :data="uploadData"
                    :on-success="btnImgSuccess"
                    :on-change="btnImgChange"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :file-list="fileListImages"
                    :multiple="true"
                    :limit="9"
                    :action="API_URL+'index/ajax/upload'"
                    list-type="picture-card"
                    accept="image/png, image/jpeg, image/jpg">
                  <i class="el-icon-plus"/>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img :src="dialogImageUrl" width="100%" alt="">
                </el-dialog>
              </el-form-item>

              <el-form-item>
                <div class="submit-btn" @click="onSubmit">提交</div>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="查件记录">
          <div class="content">
            <el-table
                v-loading="loading"
                :data="tableData"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                style="width: 100%">
              <el-table-column prop="id" label="工单编号"/>
              <el-table-column prop="express_no" label="运单号" width="180px"/>
              <el-table-column prop="desc" label="类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.type | typeName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.status | statusName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="desc" label="描述">
                <template slot-scope="scope">
                  <span>{{ scope.row.desc }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="提交图片">
                <template slot-scope="scope">
              <span>
                <img v-for ="item in scope.row.images" :src="API_URL+item" :key="item" class="ImageStyle" alt="">
              </span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="回复内容">
                <template slot-scope="scope">
                  <span>{{ scope.row.reply_desc }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="回复图片">
                <template slot-scope="scope">
              <span>
                <img v-for ="item in scope.row.reply_images" :src="API_URL+item" :key="item" class="ImageStyle" alt="">
              </span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createtime | formatDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="回复时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.reply_time | formatDate }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="pages-box">
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="param.page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="param.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>

import headerNav from "@/components/headerNav/index"
import userNav from "@/components/userNav/index"
import footerBox from "@/components/footerBox/index"
import {getToken} from "@/api/auth"
import {apiAfterWardsPut, apiAfterWardsGet} from "@/api/api"
export default {
  name: "aftermarket",
  components: {headerNav, userNav, footerBox},
  data(){
    return{
      loading: false,
      totalCount: 0,
      param: {
        limit: 20,
        page: 1
      },
      total: 0,
      tableData: [],
      uploadData: {},
      fileListImages: [],
      dialogVisible: false,
      dialogImageUrl: '',
      rules: {
        type: [{ required: true, message: '请选择工单类型', trigger: 'blur' }],
        express_nos: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
        desc: [{ required: true, message: '请输入问题描述', trigger: 'blur' }]
      },
      form: {
        type: 'sheet', // sheet：底单申请 parts：物流异常 other：其他问题
        express_nos: '',
        desc: '',
        images: []
      },
      uploadFilterUid: []
    }
  },
  filters: {
    statusName: function(val) {
      if (val === 1) {
        return '已完成'
      } else {
        return '待处理'
      }
    },
    formatDate: function(time) {
      if (!time) {
        return '-'
      }
      time = time * 1000
      var re = /-?\d+/
      var m = re.exec(time)
      if(!m) return '-';
      var d = new Date(parseInt(m[0]))
      var o = {
        'M+': d.getMonth() + 1, // month
        'd+': d.getDate(), // day
        'h+': d.getHours(), // hour
        'm+': d.getMinutes(), // minute
        's+': d.getSeconds(), // second
        'q+': Math.floor((d.getMonth() + 3) / 3), // quarter
        'S': d.getMilliseconds() // millisecond
      }
      var format = 'yyyy-MM-dd'
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
      }
      return format
    },
    typeName: function(val) {
      if (val === 'sheet') {
        return '底单申请'
      } else if (val === 'parts') {
        return '漏件无物流'
      } else if (val === 'other') {
        return '其他'
      } else {
        return '-'
      }
    }
  },

  mounted() {
    this.uploadData = {
      token: getToken()
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true
      apiAfterWardsGet(this.param).then(res => {
        this.tableData = res.data.rows
        this.totalCount = res.data.total
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.param.limit = val;
    },
    handleCurrentChange(val) {
      this.param.page = val;
    },
    btnImgChange(file, fileList) {
      if (!this.uploadFilterUid.includes(file.uid)) {
        this.fileListImages.push(file)
        this.uploadFilterUid.push(file.uid)
      }
    },
    btnImgSuccess(response, file, fileList) {
      this.form.images.push(response.data.url);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(image) {
      this.form.images.forEach((item, index) => {
        if (item === image) {
          this.form.images.splice(index, 1)
        }
      })
    },

    onSelectType(val) {
      this.form.title = val
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.form);
          let images = []
          if (this.fileListImages.length > 0) {
            this.fileListImages.forEach((item, index) => {
              images.push(item.response.data.url)
            })
            data.images_link = images
          }
          apiAfterWardsPut(data).then(res => {
            if (res.code == 1) {
              this.$message.success('提交成功')
              this.form = {
                type: 'sheet', // sheet：底单申请 parts：物流异常 other：其他问题
                express_nos: '',
                desc: '',
                images: []
              }
              this.$refs['form'].resetFields()
            }
          })
        }
      })
    }
  }
}
</script>

<style>
.el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.el-tabs__item {
  padding: 0 60px !important;
}

.el-tabs--border-card > .el-tabs__header {
  background-color: #E4E4E4;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #000000 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #000;
}

.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  border: none;
}

.el-table td {
  color: #000000;
  font-size: 12px;
}
</style>
<style scoped lang="scss">
.aftermarket {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 270px);

      .content {
        padding: 20px;

        .submit-btn{
          width: 100px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          background-color: #0f375a;
          color: #000;
          font-size: 14px;
          cursor: pointer;
        }

        .pages-box{
          margin-top: 20px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/aftermarket/index.vue